<template>
  <div class="min-w-0 max-w-full">
    <img
      v-if="logo"
      :src="logo.src"
      :class="logoClasses"
      :style="logoStyle"
      :alt="nomeEmpresa"
    />
  </div>
</template>

<script>
import logoHeader from "@/assets/logoHeader.png";
import logoVortex from "@/assets/dnways.png";
import logoActual from "@/assets/logoActual_v2.png";
import logoGenial from "@/assets/logogenial.png";
import logoRji from "@/assets/logo/rji.png";
import logoLastro from "@/assets/logoLastro.jpg";
import logoOslo from "@/assets/logo/oslo.svg";
import logoIntra from "@/assets/logo/intra.png";

const headerLogo = { src: logoHeader, darkClass: "dark:brightness-200" };
const logos = {
  BRITECH: headerLogo,
  DNWAYS_DEMO_Y: headerLogo,
  DNWAYS_DEMO_X: headerLogo,
  DNWAYS: headerLogo,
  VORTEX: { src: logoVortex, darkClass: "dark:brightness-200" },
  ACTUAL: { src: logoActual, darkClass: "dark:logo-invert-dark" },
  GENIAL: {
    src: logoGenial,
    lightFilter: "none",
    darkFilter: "invert(1)",
    pjDarkFilter: "brightness(0) invert(1)",
    darkClass: "dark:brightness-200",
    pjDarkClass: "",
  },
  RJI: {
    src: logoRji,
    darkClass: "dark:brightness-200",
    lightFilter: "invert(1)",
    darkFilter: "none",
    pjDarkFilter: "brightness(0) invert(1)",
  },
  LASTRO: { src: logoLastro, darkClass: "dark:brightness-200" },
  INTRA: {
    src: logoIntra,
    lightFilter: "none",
    darkFilter: "brightness(0) invert(1)",
  },
  OSLO: {
    src: logoOslo,
    darkClass: "dark:brightness-200",
    lightFilter: "none",
    darkFilter: "brightness(0) invert(1)",
  },
};

export default {
  name: "CompanyLogo",
  props: {
    nomeEmpresa: {
      type: String,
      default: () => process.env.VUE_APP_NOME_EMPRESA || "",
    },
    isDark: { type: Boolean, default: false },
    variant: { type: String, default: "cadastro" },
    // null preserves automatic brand filters in existing headers.
    invert: { type: Boolean, default: null },
  },
  computed: {
    logo() {
      if (this.variant === "auth" && process.env.VUE_APP_URL_LOGO) {
        return { src: require("@/" + process.env.VUE_APP_URL_LOGO) };
      }
      const company = this.nomeEmpresa.trim().toUpperCase();
      return Object.prototype.hasOwnProperty.call(logos, company)
        ? logos[company]
        : null;
    },
    logoClasses() {
      if (!this.logo) return [];
      if (this.variant === "auth" || this.invert !== null) {
        return ["company-logo"];
      }
      const darkClass =
        this.variant === "pj"
          ? this.logo.pjDarkClass ?? this.logo.darkClass
          : this.logo.darkClass;
      return ["company-logo", darkClass];
    },
    logoStyle() {
      if (this.variant === "auth" || this.invert !== null) {
        if (!this.invert) return { filter: "none" };
        return {
          filter: this.isDark ? "brightness(0) invert(1)" : "brightness(0)",
        };
      }
      if (!this.logo || !this.logo.lightFilter) return {};
      const darkFilter =
        this.variant === "pj"
          ? this.logo.pjDarkFilter || this.logo.darkFilter
          : this.logo.darkFilter;
      return { filter: this.isDark ? darkFilter : this.logo.lightFilter };
    },
  },
};
</script>
